import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';

import { ClearAllQuickViewsDataViewsCache } from '@resources/tests.graphql';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';

import { replaceCancelButtonAction } from '../helpers';

const removeCancelButton = document => {
  document.getElementById('tbbCancel')?.remove();
};

const ManageMyStudentAccessLists = () => {
  const history = useHistory();
  const location = useLocation();

  /**
   * This calls an API to remove the QuickViewsDataViews on the server side and also removes them client
   * side so the next time the user requests QuickViewsDataViews they'll get the correct data
   */
  const [clearAllDataViewsCache] = useMutation(ClearAllQuickViewsDataViewsCache, {
    update: cache => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'quickViewsDataViewType' });
      cache.gc();
    }
  });

  window.top.resetDataViewsCache = () => {
    clearAllDataViewsCache();
  };

  useEffect(() => {
    window.top.resetDataViewsCache = () => {
      clearAllDataViewsCache();
    };

    return () => delete window.top.resetDataViewsCache;
  }, []);

  const redirectFn = () => {
    history.push('manage-my-student-access-lists');
  };

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/students/monitorlists/managelists.aspx"
      title="Manage My Student Access Lists"
      key={location.key}
      onLoadCallback={iframe => {
        replaceCancelButtonAction({
          iframe,
          redirectFn,
          postReplaceFn: removeCancelButton
        });
      }}
    />
  );
};

export default ManageMyStudentAccessLists;
